var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',_vm._l((_vm.page.data.layout),function(section,index){return _c(section.type,{key:index,tag:"component",attrs:{"fields":section.fields}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }